import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Radio, RadioGroup } from '../../../components/material-ui/Radio';
import { FormControlLabel } from '../../../components/material-ui/FormControlLabel';
import { Typography } from '../../../components/material-ui/Typography';

export const SelectionType = {
    CURRENT: 0,
    NEXT: 1,
};

const styles = {
    radioButton: {
        flex: '1 0 30%',
    },
};

export const GpsRouteSelectionType = memo(({ selectionType, onChangeSelectionType }) => {
    const { t: translate } = useTranslation();

    return (
        <>
            <Typography>{translate('labels.highlightDetectedPoint')}:</Typography>
            <RadioGroup
                name="typeName"
                value={selectionType}
                className="navroute-settings__selection-type"
                onChange={onChangeSelectionType}
            >
                <FormControlLabel
                    value={SelectionType.CURRENT}
                    control={<Radio color="primary" />}
                    label={translate('current')}
                    style={styles.radioButton}
                />
                <FormControlLabel
                    value={SelectionType.NEXT}
                    control={<Radio color="primary" />}
                    label={translate('next')}
                    style={styles.radioButton}
                />
            </RadioGroup>
        </>
    );
});
